// extracted by mini-css-extract-plugin
module.exports = {"SocialLinks":"_58qPp"};